(ns frontend.intercom
  (:require
   [clojure.string :as string]
   [common.util :as cu]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]))

(defn get-intercom
  []
  (or (.-Intercom js/window)
      (constantly nil)))

;; DO NOT SEND INTERCOM MESSAGES IF USER is from zapflow.com

(defn activate
  [intercom-id intercom-hash account opts]
  (js/console.log "activate intercome")
  (swap! session/session assoc :intercom-hash intercom-hash)
  (let [tenant (:tenant opts)]
    (when (and (not (session/is-guest?))
               (not (:tenant/sandbox? tenant))
               (not (session/sys-admin?))
               ;(not (string/ends-with? (cu/str-trim-lcase (:account/email @session/account)) "zapflow.com"))
               )
      (let [intercom-widget (get-intercom)]
        (js/console.log "Iintercom " intercom-widget)
        (intercom-widget "boot"
                         (clj->js
                          {:app_id    intercom-id
                           :user_id   (str (or (:sandbox/real-entity-id account)
                                               (:db/id account)))
                           :user_hash intercom-hash
                           :email     (:account/email account)
                           :company   {:id             (str (:db/id tenant))
                                       :name           (:tenant/name tenant)
                                       :hubspot-id     (:common/hubspot-id tenant)
                                       :Classic        true
                                       :sample-company (if (or (:sandbox/real-entity-id account)
                                                               (:tenant/sandbox? tenant))
                                                         1
                                                         0)}
                           :role      (if (session/is-admin?) "Admin" "User")
                           :guest     (if (session/is-guest?) 1 0)
                           :tenant    (:tenant/name (:tenant opts))
                           :name      (str (:account/first-name account) " " (:account/last-name account))
                           :widget    {:activator "#IntercomDefaultWidget"}}))))))

(defn event
  [event-key]
  (when-not (session/is-guest?)
    (when-let [intercom-widget (get-intercom)]
      (try
        (intercom-widget "trackEvent" event-key)
        (catch js/Object e
          (logging/warn (str "Failed to track intercom event :" e)))))))

(defn shutdown
  []
  ((get-intercom) "shutdown"))

(defn show-new-message
  []
  ((get-intercom) "showNewMessage" "Feedback/suggestion: "))

(defn track-event
  [name]
  ((get-intercom) "trackEvent" name))

(defn hide
  []
  ((get-intercom) "update" (clj->js {"hide_default_launcher" true})))

(defn show
  []
  ((get-intercom) "update" (clj->js {"hide_default_launcher" false})))
